var Form = {
	settings: {
		url: '/sourcerer/ajax/send.php'
	}
};


Form.send = function(event, token){
	jQuery('#contact-form').unbind('submit').submit(Form.ajaxRequest(event, token));
}

Form.ajaxRequest = function(token){

	var formData = jQuery('#contact-form').serializeArray();

	if(!token)
		throw new "Token from front is not attached to function!";

	formData.push({ name: "token", value: token });
	
	jQuery.ajax({
		
		url: Form.settings.url,
		method: "POST",
		type: "POST",
		data: formData,
		success: function(data){
			swal({
			  title: 'OK!',
			  type: 'success',
			}).then(function (){
				location.reload(true);
			});
		},
		error: function(data){
			let htmlError = '';
			try {
				htmlError = (data.responseJSON) ?  data.responseJSON.fails  : JSON.parse(data.responseText).fails
			} catch (error) {
				htmlError = 'Error!';
			}

			jQuery('#contact-form').find('.btn').attr("disabled", false);
			swal({
			  title: 'Error!',
			  type: 'error',
			  html: htmlError
			});
			grecaptcha.reset();
		}
	});
}
export default Form;


// WEBPACK FOOTER //
// ./_dev/js/send.js